import { Component } from '@angular/core';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';

@Component({
    selector: 'kx-device-auth',
    templateUrl: './device-auth.component.html',
    styleUrls: ['./device-auth.component.scss'],
    standalone: false
})
export class DeviceAuthComponent {
  public config:any={};
  constructor(
   public appService: AppService,
   public baseService: BaseService,
   private storageService: StorageService,
  ) {
    this.config.deviceID = this.appService.readCookie('device_id');
    if(this.config.deviceID != undefined && this.config.deviceID) {
      this.config.deviceID = this.config.deviceID.split('__')[0];
    }else{
      this.baseService.logout();
    }
  }
  ngOnInit() {
    this.startRequest();
  }
  

  checkIfAuthenticated() {
    var datasource = {
      query_id: "CHECK_IF_AUTHENTICATED",
      args : "",
      filter : "",
      resource: "device_auth_request",
      application: "account-management"
    }
    this.baseService.getByDataSource(datasource).subscribe(
      (res: any) => {
      console.log("data in response in banner detail is :: ", res);
      if (res.errCode == -1) {
        this.baseService.logout();
      } else {
        if(res.resource!= undefined && res.resource.length > 0) {
            if(res.resource[0].status == 'approved'){
              window.location.href = window.location.origin;
              this.storageService.reloadOtherTab();
            }else if(res.resource[0].status == 'pending'){
              this.startRequest();
            }else{
              this.baseService.logout();
            }
        }else{
          this.baseService.logout();
        }
      }
      
    }, error => {
      this.startRequest();
    });
  }

  startRequest(){
    clearTimeout(this.config.timeId)
    this.config.timeId = setTimeout(() => {
      this.checkIfAuthenticated();
    }, 10000);
  }

  logout(){
    this.baseService.logout();
  }
  ngOnDestroy(){
    clearTimeout(this.config.timeId)
  }
}
